import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Restaurant} from "../../shared/model/restaurant";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {Overlay} from "angular2-modal";
import {Router} from "@angular/router";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {AuthService} from "../../shared/security/auth.service";
import {UserService} from "../../shared/services/user/user.service";
import {User} from "../../shared/model/user";



@Component({
  selector: 'restaurant-create',
  templateUrl: 'restaurant-create.component.html',
  styleUrls: ['restaurant-create.component.css']
})
export class RestaurantCreateComponent implements OnInit {
  restaurant: Restaurant;
  selectedState:string;
  user : User;
  fakeRestaurat : Restaurant;

  constructor(
    private restaurantservice:RestaurantService,
    private authservice:AuthService,
    private userservice:UserService,
    private router: Router,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
  ) {

    this.restaurant = Object.assign({});


  }

  ngOnInit() {

   // this.initializeForm();
    //Done: Remove latter (only for Testing Purpose


    // TODO: Uncoment the line below after testing create
     this.restaurant.state = "Select a state";


  }


  initializeForm(){

    this.fakeRestaurat = Object.assign({
      isActive: true,
      restaurant: "TESTING CREATE",
      address: "485 Little RD",
      city: "Owensboro",
      state: "Kentucky",
      zip: "81284",
      agreed: true,
      latitude: "-9.466882",
      longitude: "16.956125"
    })

    this.restaurant = this.fakeRestaurat;

  }

  Create(form) {

    // form.value.isActive.valid = true;

    const isValid = form.valid;


    if (isValid){


      this.restaurant.restaurant = form.value.restaurant;
      this.restaurant.address = form.value.address;
      this.restaurant.city = form.value.city;
      this.restaurant.state = form.value.state;
      this.restaurant.zip = form.value.zip;
      this.restaurant.isActive = form.value.isActive;
      this.restaurant.edit = "<span class=\"glyphicon glyphicon-edit\"></span>";
      this.restaurant.latitude = form.value.latitude;
      this.restaurant.longitude = form.value.longitude;
      this.restaurant.agreed = true;


      // DONE: get Coordinates



      let userID = this.authservice.getUid();
      const getUserKey$ = this.userservice.getUser(userID);
      getUserKey$
        .subscribe((user) => {
          this.createRestaurant(this.restaurant,user.$key,user.email);
        })



    } else {




      form.showErrors();

    }





  }



   reset(form) {

   form.setBlank();

   }



  select(selectedState:string) {

    this.selectedState = selectedState;

  }


  cancel() {
    this.router.navigate(['/restaurants'])
  }


  private createRestaurant(restaurant:Restaurant,userId:string,email:string){

    const createRestaurant$ = this.restaurantservice.createNewRestaurant(restaurant,userId,email);
    createRestaurant$
      .subscribe(() =>
      {
        this.router.navigate(['/restaurants'])
      },err => this.messageIt('Error creating restaurant ',err))



  }


  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }



}



// WEBPACK FOOTER //
// ./src/app/restaurant/restaurant-create/restaurant-create.component.ts